module.exports = __webpack_public_path__ + "static/media/tensor_logo.f0b130fa.gif";